import { useState } from "react";
import { Bot } from "lucide-react";
import AppPageLoader from "../components/AppPageLoader";
import UserTelegramControls from "../components/UserTelegramControls";
import "./Network.css";
import "./TelegramReporting.css";

export default function TelegramReporting() {
  const [pageLoading, setPageLoading] = useState(true);

  return (
    <div
      className={`network-page telegram-hub-page${pageLoading ? " telegram-hub-page-bootstrapping" : ""}`}
    >
      {pageLoading ? (
        <div className="telegram-hub-page-loading">
          <AppPageLoader
            label="Loading Telegram Hub"
            detail="Fetching your Telegram status, destination, and reporting controls..."
          />
        </div>
      ) : (
        <div className="network-header">
          <div className="network-header-copy">
            <h1>
              <Bot className="network-header-icon" />
              <span>Telegram Hub</span>
            </h1>
            <p>
              Connect Telegram, control report delivery, and keep the reporting service in sync with
              your account.
            </p>
          </div>
        </div>
      )}

      <UserTelegramControls onInitialLoadStateChange={setPageLoading} />
    </div>
  );
}
